import LegalPage from "@/components/feature/LegalPage";

const H2 = "font-heading text-lg md:text-xl text-foreground-950 mb-3";

const linkClass = "text-primary-600 hover:text-primary-700 transition-colors cursor-pointer";

export default function Datenschutz() {
  return (
    <LegalPage
      title="Datenschutzerklärung"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten gemäß Art. 13 DSGVO. Stand: September 2026."
    >
      <div>
        <h2 className={H2}>1. Verantwortlicher</h2>
        <p>
          Verantwortlicher für die Verarbeitung personenbezogener Daten auf
          dieser Website ist:
          <br />
          Financial World Vertriebs-GmbH
          <br />
          Hallesche Str. 4
          <br />
          66121 Saarbrücken
          <br />
          E-Mail:{" "}
          <a href="mailto:info@smilewhitefirst.de" className={linkClass}>
            info@smilewhitefirst.de
          </a>
          <br />
          Telefon: 0681 93356881
        </p>
      </div>

      <div>
        <h2 className={H2}>2. Aufruf unserer Website und Hosting</h2>
        <p>
          Beim Aufruf unserer Website werden durch den eingesetzten Webserver
          technisch erforderliche Informationen verarbeitet. Hierzu können
          insbesondere die IP-Adresse, Datum und Uhrzeit des Zugriffs, die
          aufgerufene Seite, Browsertyp, Betriebssystem sowie die zuvor
          aufgerufene Seite gehören. Die Verarbeitung ist erforderlich, um die
          Website technisch bereitzustellen sowie deren Sicherheit und
          Stabilität zu gewährleisten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
          DSGVO.
        </p>
        <p className="mt-4">
          Für Erstellung, Hosting und Bereitstellung der Website setzen wir
          Webflow, Inc., USA, ein. Webflow verarbeitet dabei Daten in unserem
          Auftrag. Eine Verarbeitung von Daten in den USA kann nicht
          ausgeschlossen werden. Webflow ist nach dem EU-US Data Privacy
          Framework zertifiziert; ergänzend bestehen vertragliche Regelungen zum
          Schutz personenbezogener Daten.
        </p>
      </div>

      <div>
        <h2 className={H2}>3. Kontaktaufnahme</h2>
        <p>
          Wenn Sie uns per E-Mail, Telefon oder über das auf der Website
          bereitgestellte Kontaktformular kontaktieren, verarbeiten wir die von
          Ihnen mitgeteilten Daten ausschließlich zur Bearbeitung Ihrer Anfrage
          und einer gegebenenfalls anschließenden Kommunikation.
        </p>
        <p className="mt-4">
          Soweit Ihre Anfrage auf den Abschluss oder die Durchführung eines
          Vertrages gerichtet ist, erfolgt die Verarbeitung gemäß Art. 6 Abs. 1
          lit. b DSGVO. Im Übrigen erfolgt sie auf Grundlage unseres
          berechtigten Interesses an der Bearbeitung von Anfragen gemäß Art. 6
          Abs. 1 lit. f DSGVO. Über das Kontaktformular übermittelte Daten
          können im Rahmen der technischen Bereitstellung des Formulars durch
          Webflow verarbeitet werden.
        </p>
        <p className="mt-4">
          Die Daten werden gelöscht, sobald sie für die Bearbeitung der Anfrage
          nicht mehr erforderlich sind und keine gesetzlichen
          Aufbewahrungspflichten entgegenstehen.
        </p>
      </div>

      <div>
        <h2 className={H2}>4. Online-Terminbuchung über Shore</h2>
        <p>
          Zur komfortablen Online-Terminbuchung nutzen wir den Dienst Shore der
          Shore GmbH, Lothstr. 19, 80797 München. Wenn Sie auf „Jetzt Termin
          vereinbaren“ klicken, werden Sie auf die Buchungsplattform von Shore
          weitergeleitet.
        </p>
        <p className="mt-4">
          Im Rahmen der Terminbuchung werden insbesondere die von Ihnen
          angegebenen Kontakt- und Buchungsdaten, etwa Name, E-Mail-Adresse,
          Telefonnummer, gewünschte Leistung sowie Datum und Uhrzeit des
          Termins, verarbeitet. Die Verarbeitung erfolgt zur Bearbeitung Ihrer
          Terminanfrage sowie zur Vorbereitung und Durchführung des gewünschten
          Vertragsverhältnisses auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
          Shore verarbeitet die Daten insoweit als von uns eingesetzter
          Dienstleister. Nach Angaben von Shore befinden sich die hierfür
          eingesetzten Server in Deutschland.
        </p>
        <p className="mt-4">
          Bitte übermitteln Sie über Freitextfelder keine Gesundheitsdaten oder
          sonstigen besonders sensiblen Informationen, soweit dies für die
          Terminvereinbarung nicht erforderlich ist.
        </p>
      </div>

      <div>
        <h2 className={H2}>5. Cookies und Einwilligungsmanagement</h2>
        <p>
          Unsere Website verwendet technisch erforderliche Cookies und
          vergleichbare Technologien, die für die Bereitstellung und
          Funktionsfähigkeit der Website notwendig sind. Die Speicherung oder
          der Zugriff auf Informationen auf Ihrem Endgerät erfolgt insoweit auf
          Grundlage von § 25 Abs. 2 TDDDG; die anschließende Verarbeitung
          personenbezogener Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
          DSGVO.
        </p>
        <p className="mt-4">
          Darüber hinaus können Analyse-, Personalisierungs- oder
          Marketingtechnologien eingesetzt werden. Diese werden nur aktiviert,
          wenn Sie zuvor über unseren Cookie-Banner eingewilligt haben.
          Rechtsgrundlagen sind § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a
          DSGVO. Eine erteilte Einwilligung können Sie jederzeit über die auf
          der Website erreichbaren „Cookie-Einstellungen“ mit Wirkung für die
          Zukunft widerrufen.
        </p>
      </div>

      <div>
        <h2 className={H2}>6. Google-Dienste</h2>
        <p>
          Wir nutzen den Google Tag Manager der Google Ireland Limited, Gordon
          House, Barrow Street, Dublin 4, Irland, zur technischen Verwaltung
          weiterer Website-Tags. Über den Google Tag Manager können
          insbesondere Analyse- und Marketingdienste von Google, etwa zur
          Messung des Erfolgs von Werbemaßnahmen, eingebunden werden. Soweit
          dabei nicht technisch erforderliche Daten auf Ihrem Endgerät
          gespeichert oder ausgelesen bzw. personenbezogene Daten verarbeitet
          werden, erfolgt dies ausschließlich nach Ihrer Einwilligung gemäß
          § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a DSGVO.
        </p>
        <p className="mt-4">
          Darüber hinaus ist auf unserer Website Google Maps eingebunden. Google
          Maps ermöglicht die Darstellung unseres Standorts und die Nutzung von
          Kartenfunktionen. Beim Aufruf der Karte können insbesondere Ihre
          IP-Adresse sowie technische Nutzungsinformationen an Google
          übertragen werden. Die Einbindung erfolgt auf Grundlage Ihrer
          Einwilligung gemäß § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a DSGVO.
        </p>
        <p className="mt-4">
          Bei Diensten von Google kann eine Verarbeitung durch die Google LLC in
          den USA erfolgen. Google nimmt am EU-US Data Privacy Framework teil.
        </p>
      </div>

      <div>
        <h2 className={H2}>7. Speicherdauer</h2>
        <p>
          Personenbezogene Daten werden grundsätzlich nur so lange gespeichert,
          wie dies für den jeweiligen Verarbeitungszweck erforderlich ist.
          Anschließend werden die Daten gelöscht, sofern keine gesetzlichen,
          insbesondere handels- oder steuerrechtlichen Aufbewahrungspflichten
          eine längere Speicherung erfordern.
        </p>
      </div>

      <div>
        <h2 className={H2}>8. Ihre Rechte</h2>
        <p>
          Sie haben nach Maßgabe der gesetzlichen Voraussetzungen das Recht auf
          Auskunft über die zu Ihrer Person gespeicherten Daten, auf Berichtigung
          unrichtiger Daten, Löschung, Einschränkung der Verarbeitung sowie
          Datenübertragbarkeit. Einer auf Art. 6 Abs. 1 lit. f DSGVO beruhenden
          Verarbeitung können Sie aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, widersprechen. Eine erteilte Einwilligung können
          Sie jederzeit mit Wirkung für die Zukunft widerrufen.
        </p>
        <p className="mt-4">
          Darüber hinaus haben Sie das Recht, sich bei einer
          Datenschutzaufsichtsbehörde zu beschweren. Zuständige Aufsichtsbehörde
          ist insbesondere:
        </p>
        <p className="mt-4">
          Unabhängiges Datenschutzzentrum Saarland
          <br />
          Fritz-Dobisch-Straße 12
          <br />
          66111 Saarbrücken
          <br />
          E-Mail:{" "}
          <a href="mailto:poststelle@datenschutz.saarland.de" className={linkClass}>
            poststelle@datenschutz.saarland.de
          </a>
        </p>
      </div>
    </LegalPage>
  );
}